import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    marginTop: 0,
    padding: "0",
    boxSizing: "border-box",
    overflowX: "auto",
    backgroundColor: "#fff",
  },
  messagesContainer: {
    width: "100%",
    padding: "0",
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "center",
    marginTop: 8,
    paddingTop: 8,
    paddingBottom: 4,
  },
  viewAllButton: {
    backgroundColor: "#ec6535",
    color: "#fff",
    textTransform: "none",
    borderRadius: "2rem",
    padding: "10px 24px",
    fontSize: "0.938rem",
    fontWeight: 500,
    "&:hover": {
      backgroundColor: "#d4552a",
    },
  },
}));

